import { useFormContext } from 'react-hook-form'

const useService = (serviceName: string) => {
  const { getValues } = useFormContext()

  const service = getValues(`productServices.${serviceName}`)
  const hasCustomization = service?.customization?.name

  return { service, hasCustomization }
}

export default useService
